import "./EntityImport.scss";
import ErrorDialog from "../../../components/errorDialog/ErrorDialog";
import ProgressDialog from "../../../components/progressDialog/ProgressDialog";
import { CustomLoadingButton } from "../../../components/ui/CustomButton";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect";
import newRequest from "../../../utils/newRequest";
import PublishIcon from "@mui/icons-material/Publish";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableContainer,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
  Accordion,
  AccordionDetails,
  AccordionSummary
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { MdAttachment, MdClose, MdOutlineCheck, MdOutlineFileDownload, MdOutlineFileUpload } from "react-icons/md";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import readXlsxFile from "read-excel-file";
import { useTranslation } from 'react-i18next';
import { IoIosRemoveCircle } from "react-icons/io";
import { SlArrowDown } from "react-icons/sl";
import { PiWarningFill } from "react-icons/pi";
import { FiSearch } from "react-icons/fi";
import { generateUniqueCode } from "../../../utils/genericFunctions";


const EntityImport = () => {
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [excelData, setExcelData] = useState([]);
  const [showUpload, setShowUpload] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState("");
  const [openProgressDialog, setOpenProgressDialog] = useState(false);
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const fileInputRef = useRef(null);
  const [expanded, setExpanded] = useState(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Update filtered data when the search term changes
  useEffect(() => {
    const filteredResults = excelData.filter(
      (item) =>
        item?.ent_name?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
        item?.ent_id_no?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
        item?.ent_tax_no?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
        item?.ent_phone_no?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
        item?.ent_email?.toLowerCase().includes(searchTerm?.toLowerCase())
    );
    setFilteredData(filteredResults);
  }, [excelData, searchTerm]);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [selectedEntityCatg, setSelectedEntityCatg] = useState({});
  const [entityCatgOptions, setEntityCatgOptions] = useState([]);

  useEffect(() => {
    const fetchEntityCatg = async () => {
      try {
        const res = await newRequest.get("/allEntityCatg/findAll");

        const options = res.data.map((entityCatg) => ({
          value: entityCatg?.aent_code,
          label: entityCatg?.aent_name,
        }));

        setEntityCatgOptions(options);

        setSelectedEntityCatg({
          value: "Client",
          label: "Client",
        });

      } catch (error) {
        console.error("Error fetching entity types:", error);
      }
    };
    fetchEntityCatg();
  }, [currentUser]);

  const slicedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handleClearSearch = () => {
    setSearchTerm("");
  };

  const handleAccodionChange = (id, vrow) => (event, isExpanded) => {
    setExpanded(isExpanded ? id : null);
  };


  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    setShowUpload(false);
    if (!file) return;
    let errorsCount = 0;

    setUploading(true);


    try {
      const rows = await readXlsxFile(file, { sheet: 2 });
      const data = rows.slice(1).map((row, index) => {
        const ent_code = row[0];
        const ent_name = row[1] || "";
        const ent_type = row[2] || "";
        const ent_tax_no = row[3] || "";
        const ent_phone_no = row[4];
        const ent_email = row[5] || "";
        const ent_id_no = row[6] || "";
        const ent_license_no = row[7] || "";
        const ent_physical_address = row[8] || "";
        const ent_postal_address = row[9] || "";
        const ent_gender = row[14] || "";
        let result_xx = "Ready for upload";


        // Perform your checks here
        if (ent_type) {
          if (!["Corporate", "Government", "Individual", "NGO", "Unspecified"].includes(ent_type)) {
            result_xx = "Entity Type MUST be Corporate, Government, Individual, NGO or Unspecified";
            errorsCount++;
          }
        } else {
          result_xx = "Entity Type MUST be Specified";
          errorsCount++;
        }

        if (ent_gender) {
          if (!["Female", "Male", "Non-Binary", "Unspecified"].includes(ent_gender)) {
            result_xx = "Entity Gender MUST be Female, Male, Non-Binary or Unspecified";
            errorsCount++;
          }
        }

        const rowid = generateUniqueCode();
        return {
          _id: rowid,
          ent_code,
          ent_name,
          ent_type,
          ent_tax_no,
          ent_phone_no,
          ent_email,
          ent_id_no,
          ent_license_no,
          ent_physical_address,
          ent_postal_address,
          ent_gender,
          result_xx,
          index
        };
      });

      setExcelData(data);
      setUploading(false);

      if (errorsCount === 0) {
        setShowUpload(true)
      }

    } catch (error) {
      console.error("Error reading Excel file:", error);
      setUploading(false);
    }
  };

  const handleCloseDialog = () => {
    setError("");
  };

  const updateRecordStatus = (index, result_xx, ent_code) => {
    try {
      const updatedData = [...excelData];
      const currentRow = updatedData[index];
      currentRow["result_xx"] = result_xx;
      currentRow["ent_code"] = ent_code;
      setExcelData(updatedData);
    } catch (error) {
      console.log(error);
    }
  };

  const resetFile = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
      console.log("File input reset");
    }
  };

  const handleSubmit = async () => {
    try {

      if (!selectedEntityCatg?.value) {
        setError("Please select a category");
        return;
      }

      setOpenProgressDialog(true);

      const responseArray = [];
      const totalRecords = excelData.length;
      let completedRecords = 0;

      for (const record of excelData) {
        const progress = Math.round((completedRecords / totalRecords) * 100);
        setProgress(progress);

        const entity = {
          ...record,
          record_index: completedRecords,
          ent_status: "Active",
          ent_aent_code: selectedEntityCatg.value
        };

        let res = {};

        try {
          res = await newRequest.post("/allEntity/upload", entity);
        } catch (error) {
          console.log(error);
        }

        const responseData = await res.data;

        responseArray.push(responseData);

        completedRecords++;
      }


      let uploadedCount = 0;
      let restCount = 0;
      // loop to update response data
      for (const record of responseArray) {
        if (record.response === "Uploaded") {
          uploadedCount++;
        } else {
          restCount++;
        }

        updateRecordStatus(
          record.record_index,
          record.response,
          record.ent_code
        );
      }

      setProgress(100);
      setOpenProgressDialog(false);

      setNotifyDialogTitle("Please Note...");
      setNotifyDialogText(`<div>Total Records Processed <strong>${responseArray.length}</strong></div>
      <div>Successfully Uploaded <strong>${uploadedCount}</strong></div>
      <div>Errors <strong>${restCount}</strong></div>
      <div><br/></div>
      <div><p>Rectify the Records with errors and try again </p> </div>
      `);
      setIsNotifyDialogOpen(true);
    } catch (error) {
      console.error("Error uploading data:", error);
    }
  };


  return (
    <div className="entity-import">
      <div className="navbar">
        <div className="navbar-left">
          <div className="search-input-wrapper">
            <FiSearch className="search-input-icon" />
            <input
              className="search-input"
              type="text"
              placeholder={t('search')}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {searchTerm?.length > 0 && (
              <MdClose
                onClick={handleClearSearch}
                className="search-input-icon"
              />
            )}
          </div>
        </div>
        <div className="navbar-right">
          <div className="file-upload-item"
            onClick={async () => {
              try {
                const response = await newRequest.get("/uploadTemplates/entities-template", {
                  responseType: "blob",
                });
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "entities-template.xlsx");
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
              } catch (error) {
                console.log(error);
              }
            }}>
            <MdOutlineFileDownload />
            <span>{t('downloadTemplate')}</span>
          </div>
          <input
            type="file"
            accept=".xlsx, .xls"
            ref={fileInputRef}
            id="file"
            style={{ display: "none" }}
            onChange={handleFileUpload}
          />
          <label htmlFor="file">
            <div className="file-upload-item">
              <MdAttachment /> <span>{t('selectFile')}</span>
            </div>
          </label>
          {excelData?.length > 0 &&
            <div className="file-upload-item"
              onClick={async () => {
                try {
                  setExcelData([]);
                  setSearchTerm("");
                  resetFile();
                } catch (error) {
                  console.log(error);
                }
              }}>
              <IoIosRemoveCircle />
              <span>{t('reset')}</span>
            </div>}

          <Select
            id="ent_catg"
            name="ent_catg"
            styles={{
              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
              menuPortal: base => ({
                ...base,
                zIndex: 9999,
              })
            }}
            width="150px"
            value={selectedEntityCatg}
            onChange={(selectedOption) => {
              try {
                setSelectedEntityCatg(selectedOption);
              } catch (error) {
                console.log(error);
              }
            }}
            options={entityCatgOptions}
            isSearchable={true}
            placeholder={t('category')}
          />
          <CustomLoadingButton
            currentTheme={currentTheme}
            iconPosition="end"
            borderRadiusType="left"
            startIcon={<PublishIcon />}
            onClick={handleSubmit}
            disabled={excelData?.length === 0 || !selectedEntityCatg?.value || uploading}
          >
            {uploading ? "Uploading..." : "Upload"}
          </CustomLoadingButton>
          <CustomLoadingButton
            currentTheme={currentTheme}
            iconPosition="end"
            borderRadiusType="right"
            endIcon={<MdClose />}
            onClick={() => navigate(-1)}
          >
            {t('close').toUpperCase()}
          </CustomLoadingButton>
        </div>
      </div>
      {slicedData?.length > 0 &&
        <div className="table-content">
          <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }}
            className="table-container">
            <Table sx={{ width: "max-content", border: 'none' }}>
              <TableBody className="tablebody-accordion">
                {slicedData?.map((vrow, index) => (
                  <TableRow
                    key={vrow?.index}
                    className="tablerow-accordion">
                    <TableCell className="table-cell-accordion"
                      style={{
                        display: "flex",
                        width: "100%",
                        alignItems: "center",
                      }}>
                      <Accordion className="accordion" expanded={expanded === vrow?._id} onChange={handleAccodionChange(vrow?._id, vrow)}>
                        <AccordionSummary
                          className="accordion-summary"
                          expandIcon={<SlArrowDown className="content-accordion-expand-icon" style={{ color: "#f44336", fontWeight: "bold" }} />}
                          id={`panel-${vrow?._id}-header`}
                        >
                          <div style={{ display: "flex", gap: "10px", alignItems: "center", justifyContent: "space-between", width: "100%", marginRight: "50px" }}>
                            <span style={{ display: "flex", width: "50px", fontWeight: "bold" }}>{page * rowsPerPage + index + 1}</span>
                            <span style={{ display: "flex", flex: "1" }}>{vrow.ent_code || "System Gen"}</span>
                            <span style={{ display: "flex", flex: "2" }}>{vrow?.ent_name}</span>
                            <span style={{ display: "flex", flex: "1.5" }}>{vrow?.ent_type}</span>
                            <span style={{ display: "flex", flex: "0.5" }}>{vrow?.ent_phone_no}</span>
                            <span style={{ display: "flex", flex: "1" }}>{vrow?.ent_email}</span>
                            <span style={{ display: "flex", flex: "1.5" }}>{vrow?.result_xx}</span>
                            {["Ready for upload", "Uploaded"].includes(vrow?.result_xx) && <MdOutlineCheck size={20} color="green" />}
                            {!["Ready for upload", "Uploaded"].includes(vrow?.result_xx) && <PiWarningFill size={20} color="red" />}
                          </div>
                        </AccordionSummary>
                        <AccordionDetails className="accordion-details">
                          <div style={{ display: "flex", gap: "10px", padding: "5px 20px 5px 20px", alignItems: "center", width: "100%" }}>
                            <div style={{ display: "flex", flexDirection: "column", flex: "1" }}>
                              <span className="sub-title soft" style={{ fontSize: "10px" }}>{t('phoneNo').toUpperCase()}</span>
                              <span className="sub-title">{vrow?.ent_phone_no}</span>
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", flex: "2" }}>
                              <span className="sub-title soft" style={{ fontSize: "10px" }}>{t('email').toUpperCase()}</span>
                              <span className="sub-title">{vrow?.ent_email}</span>
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", flex: "1" }}>
                              <span className="sub-title soft" style={{ fontSize: "10px" }}>{t('idNumber').toUpperCase()}</span>
                              <span className="sub-title">{vrow?.ent_id_no}</span>
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", flex: "1" }}>
                              <span className="sub-title soft" style={{ fontSize: "10px" }}>{t('licenceNumber').toUpperCase()}</span>
                              <span className="sub-title">{vrow?.ent_licence_no}</span>
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", flex: "1" }}>
                              <span className="sub-title soft" style={{ fontSize: "10px" }}>{t('physicalAddress').toUpperCase()}</span>
                              <span className="sub-title">{vrow?.ent_physical_address}</span>
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", flex: "1" }}>
                              <span className="sub-title soft" style={{ fontSize: "10px" }}>{t('postalAddress').toUpperCase()}</span>
                              <span className="sub-title">{vrow?.ent_postal_address}</span>
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", flex: "1", textAlign: "right" }}>
                              <span className="sub-title soft" style={{ fontSize: "10px" }}>{t('gender').toUpperCase()}</span>
                              <span className="sub-title">{vrow?.ent_gender}</span>
                            </div>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            {filteredData?.length > rowsPerPage &&
              <TablePagination
                rowsPerPageOptions={[10]}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                component="div"
                count={filteredData?.length}
                page={page}
                onPageChange={handleChangePage}
              />}
          </TableContainer>
        </div>}
      {/* Error dialog */}
      <ErrorDialog
        open={!!error}
        handleClose={handleCloseDialog}
        errorMessage={error}
      />
      {/* progress dialog for upload  */}
      <ProgressDialog
        open={openProgressDialog}
        handleClose={() => setOpenProgressDialog(false)}
        progress={progress}
        title="Uploading Entities. Please Wait...."
      />
      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen}
        onClose={() => setIsNotifyDialogOpen(false)}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton currentTheme={currentTheme} variant="tint" color="#E040FB" onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {showUpload && (
        <CustomLoadingButton
          currentTheme={currentTheme}
          iconPosition="start"
          borderRadiusType="left"
          endIcon={<MdOutlineFileUpload />}
          onClick={handleSubmit}
          disabled={!excelData.length || uploading}
        >
          {uploading ? "Uploading..." : "Upload"}
        </CustomLoadingButton>
      )}
    </div>
  );
};

export default EntityImport;
